import { langModules, type LangCode } from './index';

export const STORAGE_KEY = 'vivatis-lang';
const SUPPORTED_LANGS: LangCode[] = ['en', 'de', 'fr', 'it', 'es', 'nl', 'pl'];

export function detectBrowserLang(): LangCode {
  if (typeof navigator === 'undefined') return 'en';

  const candidates = navigator.languages?.length
    ? navigator.languages
    : [navigator.language];

  for (const lang of candidates) {
    const code = lang.toLowerCase().split('-')[0] as LangCode;
    if (SUPPORTED_LANGS.includes(code)) {
      return code;
    }
  }

  return 'en';
}

export function loadLang(): LangCode {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'en' || (stored && stored in langModules)) {
      return stored as LangCode;
    }
  } catch {
    // ignore
  }
  // Skip browser auto-detection when offline: we can't fetch localized data,
  // so the UI would be out of sync with whatever language the cached API data
  // happens to be in. Fall back to the canonical default instead.
  if (typeof navigator !== 'undefined' && !navigator.onLine) {
    return 'en';
  }
  return detectBrowserLang();
}
